import createIcon from '../../createIcon';

/**
 * @component @name BorderOuter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgN0gxMVY5SDEzVjdaTTEzIDExSDExVjEzSDEzVjExWk0xNyAxMUgxNVYxM0gxN1YxMVpNMyAzVjIxSDIxVjNIM1pNMTkgMTlINVY1SDE5VjE5Wk0xMyAxNUgxMVYxN0gxM1YxNVpNOSAxMUg3VjEzSDlWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderOuter = createIcon('BorderOuter', [
  [
    'path',
    {
      d: 'M13 7H11V9H13V7ZM13 11H11V13H13V11ZM17 11H15V13H17V11ZM3 3V21H21V3H3ZM19 19H5V5H19V19ZM13 15H11V17H13V15ZM9 11H7V13H9V11Z',
      key: 'svlcfx',
    },
  ],
]);

export default BorderOuter;
